module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.f9c2348a.svg";